/**
 * Convierte un texto en un slug amigable para URL (SEO friendly).
 * Remueve acentos, caracteres especiales y convierte espacios a guiones.
 */
export function slugify(text: string): string {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD') // Separa caracteres con acentos
    .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
    .trim()
    .replace(/[^a-z0-9 -]/g, '') // Remueve caracteres no alfanuméricos salvo espacios y guiones
    .replace(/\s+/g, '-') // Reemplaza espacios con guiones
    .replace(/-+/g, '-'); // Reemplaza múltiples guiones por uno solo
}

/**
 * Crea una cadena slug usando solo el título formateado.
 * Ejemplo: ("Nuevo Porsche 911 GT3 RS", 15) -> "nuevo-porsche-911-gt3-rs"
 */
export function createArticleSlug(title: string | undefined | null, id?: number): string {
  const cleanSlug = title ? slugify(title) : '';
  if (cleanSlug) {
    return cleanSlug;
  }
  return id ? `${id}` : 'noticia';
}
